import { AspectRatioLabel, ASPECT_MAP } from '@anm/data/aspects';
import { DEFAULT_PAGE } from '@anm/data/video-templates/defaults';
import { PageName } from '@anm/data/video-templates/pages';
import { safeParse } from '@anm/helpers/safeOperation';
import getCalendarFetchDates from '@anm/helpers/videoTemplates/getCalendarFetchDates';
import isServer from '@anm/helpers/is/isServer';

import { TEMPLATE_STOCKS_PARAMS } from '../../../components/stocks/StockList';
import { filterActions } from '../../../store/modules/filter';
import { stockActions } from '../../../store/modules/stocks';
import { subscriptionActions } from '../../../store/modules/subscription';
import { templateActions } from '../../../store/modules/template';
import { waveEventsActions } from '../../../store/modules/waveEvents';
import { TemplateListQuery } from '../dispatchCurrentTemplateNew';
import getTemplateFiltersByQuery from '../getTemplateFiltersByQuery';

import { CommonProps, FetchSliderProps, FetchStockProps, FetchTemplateProps, TemplateViewProps } from './types';

const DEFAULT_LIMIT = 20;

export const getIsSemrush = (isSemrush?: string) => {
  try {
    console.log('SSS safeParse ', safeParse(isSemrush || 'false'));
  } catch (e) {
    console.log(e);
  }
  return safeParse(isSemrush || 'false') || (!isServer() && window.name === 'semrush_iframe');
};

export const getAspects = (aspect?: AspectRatioLabel | null | string) =>
  ASPECT_MAP[aspect as AspectRatioLabel] || aspect;

export const getPageNameOrTemplateIdFromProps = ({ pageName: pageNameOrTemplateId }: TemplateListQuery) => {
  const currentPage = (pageNameOrTemplateId as PageName) || DEFAULT_PAGE;

  return currentPage;
};

export const fetchTemplateView = ({ query, dispatch, templateIdOrSlug }: TemplateViewProps) => {
  const templateListFilters = getTemplateFiltersByQuery(query);

  dispatch(
    templateActions.fetchTemplateView({
      templateIdOrSlug,
      templateListFilters
    })
  );
};

export const fetchTemplatesForSlider = ({ dispatch, item, query }: FetchSliderProps) => {
  const aspects = query.aspects || item.search.aspects;

  console.log('FFF fetchTemplatesForSlider ', getIsSemrush(query.isSemrush));

  const params = {
    limit: DEFAULT_LIMIT,
    ...item.search,
    aspects,
    storeKey: item.name as string,
    ...(getIsSemrush(query.isSemrush) && { price_max: 0 })
  };
  dispatch(templateActions.fetchTemplatesForSlider(params));
};

export const fetchTemplatesList = ({ item, query, dispatch }: FetchTemplateProps) => {
  const name = query.name;
  const aspects = query.aspects || item.search.aspects;

  console.log('FFF fetchTemplatesList ', getIsSemrush(query.isSemrush));

  const params = {
    limit: DEFAULT_LIMIT,
    ...item.search,
    aspects,
    ...(name && { name }),
    ...(getIsSemrush(query.isSemrush) && { price_max: 0 })
  };

  return dispatch(templateActions.fetchTemplateListByFilter(params));
};

export const fetchStocks = ({ item, query, dispatch }: FetchStockProps) => {
  const { search, isImages = true } = item;
  const searchName = query.name || search.name;

  dispatch(subscriptionActions.fetchSubscriptionList());
  dispatch(
    stockActions.fetchStocks({
      isImages,
      searchName,
      ...TEMPLATE_STOCKS_PARAMS
    })
  );
};

export const fetchCalendar = ({ dispatch }: CommonProps) => {
  const calendarFetchDates = getCalendarFetchDates();

  calendarFetchDates.forEach(date => {
    dispatch(waveEventsActions.fetchWaveEventList(date));
  });
};

export const saveFilters = ({ query, dispatch }: CommonProps) => {
  const name = query.name;
  const aspects = query.aspects;

  name && dispatch(filterActions.updateSearchName(name));
  aspects && dispatch(filterActions.updateSavedFilters({ aspects }));
};

export const setPageNumber = ({ query, dispatch }: CommonProps) => {
  const pageNumber = query.pageNumber ? +query.pageNumber : 1;

  pageNumber && dispatch(templateActions.setCurrentPage(pageNumber));
};
